import clsx from 'clsx';

import { Label, LABEL_TYPE } from '@/components/generic';
import { ZeroStateBackgroundIcon } from '@/resources';

type ZeroStateProps = {
  icon: React.ReactNode;
  titleFirstLine: string;
  titleSecondLine: string;
  className?: string;
  onIconClick?: () => void;
};

export const ZeroState = ({
  icon,
  titleFirstLine,
  titleSecondLine,
  className = '',
  onIconClick
}: ZeroStateProps) => (
  <div className={`flex w-full items-center justify-center ${className}`}>
    <div
      className={clsx(
        'flex flex-col items-center justify-center text-center',
        onIconClick && 'cursor-pointer'
      )}
      onClick={onIconClick}>
      <div className='relative w-24'>
        <ZeroStateBackgroundIcon className='size-full' />
        <div className='absolute left-0 top-0 flex size-24 items-center justify-center'>
          <div className='z-10 flex size-8 justify-center text-3xl'>{icon}</div>
        </div>
      </div>
      <div className='mt-4 flex flex-col'>
        <div className='flex items-center justify-center'>
          <Label
            text={titleFirstLine}
            type={LABEL_TYPE.PARAGRAPH1_BOLD}
            className='text-secondary-steel-blue'
          />
        </div>
        <div className='flex items-center justify-center'>
          <Label
            text={titleSecondLine}
            type={LABEL_TYPE.PARAGRAPH1_BOLD}
            className='text-secondary-steel-blue'
          />
        </div>
      </div>
    </div>
  </div>
);
